import { PayloadAction } from '@reduxjs/toolkit'
import { WritableDraft } from 'immer/dist/internal'
import { ComposerState } from '../state'

export const tiktokReducers = {
  setTiktokPhotoTitle: (state: WritableDraft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.tiktok.title = action.payload
  },
  setTiktokPhotoDescription: (state: WritableDraft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.tiktok.description = action.payload
  }
}
